

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createDistrict } from "../../redux/actions/districtsActions";
import toast from "react-hot-toast";

const CreateDistricts = () => {
  const dispatch = useDispatch();
  const {
    createLoading,
    createSuccess,
    createError,
  } = useSelector((state) => state.district || {});

  const [name, setName] = useState("");
  const [stateName, setStateName] = useState("West Bengal");
  const [status, setStatus] = useState("active");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.error("District name is required");
      return;
    }

    dispatch(createDistrict({ name, state: stateName, status }));
  };

  useEffect(() => {
    if (createSuccess) {
      toast.success("District created successfully!");
      setName("");
      setStateName("West Bengal");
      setStatus("active");
    }

    if (createError) {
      const errorMessage =
        createError?.meta?.message || "Failed to create district";
      toast.error(errorMessage);
    }
  }, [createSuccess, createError]);

  return (
    <div className="w-full min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-lg mx-auto bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-6">Create District</h1>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              District Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              placeholder="Enter district name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 outline-none"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1">State</label>
            <input
              type="text"
              value={stateName}
              onChange={(e) => setStateName(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 outline-none"
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium mb-1">Status</label>
            <select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-cyan-500 outline-none"
            >
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <button
            type="submit"
            disabled={createLoading}
            className={`w-full px-4 py-2 text-white font-medium rounded-md transition ${
              createLoading
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-cyan-600 hover:bg-cyan-700"
            }`}
          >
            {createLoading ? "Creating..." : "Create District"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateDistricts;
